import { render } from "./RegisterPage.vue?vue&type=template&id=291b64e2&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=291b64e2&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291b64e2"]])

export default __exports__